import { CartContext } from "@/setup/cartProvider";
import {
  Button,
  Center,
  Container,
  Grid,
  LoadingOverlay,
  Text,
} from "@mantine/core";
import Link from "next/link";
import { useRouter } from "next/router";
import React, { useContext, useEffect } from "react";
import { CartLeftSection, CartRightSection } from "./components";

export default function Cart() {
  const { cart, isProcessingOrder } = useContext(CartContext);
  const { locale } = useRouter();

  const [height, setHeight] = React.useState(0);

  useEffect(() => {
    setHeight(window.innerHeight);
  }, []);

  useEffect(() => {
    if (isProcessingOrder) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }, [isProcessingOrder]);

  return (
    <Container my="md" size="xl">
      <LoadingOverlay visible={isProcessingOrder} sx={{ height }} />

      {cart?.length > 0 ? (
        <Grid>
          <CartLeftSection />
          <CartRightSection />
        </Grid>
      ) : (
        <Center
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Text>{locale === "vi" ? "Giỏ hàng trống" : "Cart is empty"}</Text>
          <Link
            scroll={false}
            href="/mua-hang/san-pham?sort=newest"
            style={{ display: "flex", alignItems: "center" }}
          >
            <a>
              <Button>
                <Text>
                  {locale === "vi"
                    ? "Thêm sản phẩm vào giỏ"
                    : "Add product to cart"}
                </Text>
              </Button>
            </a>
          </Link>
        </Center>
      )}
    </Container>
  );
}
